import React from "react";
import {
  CheckboxGroupItem,
  CheckboxGroupItemProps
} from "@/components/ui/checkbox-group";
import Text, { TextVariant } from "@/components/ui/text";
import { cn } from "@/utils/utils";

export interface SingleCheckboxProps extends CheckboxGroupItemProps {
  id: string;
  isChecked: boolean;
  labelVariant?: TextVariant;
  className?: string;
  containerClassName?: string;
  disabled?: boolean;
  // Shows the state but takes no input — distinct from disabled, which also
  // dims it. Used by field rows that label the checkbox themselves.
  readOnly?: boolean;
}

const SingleCheckbox: React.FC<SingleCheckboxProps> = ({
  id,
  label,
  isChecked,
  onCheckedChange,
  labelVariant = "body",
  className,
  containerClassName,
  disabled = false,
  readOnly = false,
  isCircle = false
}) => {
  // Kept unconditional: the selection checkboxes in the People and User
  // Management tables pass label="", and withholding the node there changes
  // their layout.
  const displayLabel = <Text variant={labelVariant}>{label}</Text>;

  return (
    <CheckboxGroupItem
      id={id}
      label={displayLabel}
      checked={isChecked}
      className={cn("size-4", readOnly && "pointer-events-none", className)}
      containerClassName={cn(
        readOnly && "pointer-events-none",
        containerClassName
      )}
      // pointer-events-none stops the mouse only; Space still toggles a focused
      // checkbox, so read-only has to withhold the handler itself.
      onCheckedChange={readOnly ? undefined : onCheckedChange}
      // `|| undefined` so the attribute is omitted rather than rendered as
      // aria-readonly="false" on every other checkbox in the app.
      aria-readonly={readOnly || undefined}
      disabled={disabled}
      isCircle={isCircle}
    />
  );
};

export default SingleCheckbox;
